import React, { type ReactNode, type DragEvent } from 'react';

const stopDrag = (e: DragEvent) => {
	e.preventDefault();
	e.stopPropagation();
};

/**
 * Prevents `dragstart` events from within child elements from bubbling
 */
const BlockDrag = ({ children }: { children: ReactNode }) => (
	// Need to mark this as `draggable` in order for `onDragStart`
	// to fire when attempting to drag child elements
	// eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, jsx-a11y/no-static-element-interactions
	<div draggable onDragStart={stopDrag}>
		{children}
	</div>
);

export default BlockDrag;
